export const DASHBOARD_BASE_URL = "dashboard";
export const DASHBOARD_CLUBS = `${DASHBOARD_BASE_URL}/clubs`;
export const DASHBOARD_USERS = `${DASHBOARD_BASE_URL}/users`;
export const TREASURY = `${DASHBOARD_BASE_URL}/treasury`;
export const PROPOSAL = `${DASHBOARD_BASE_URL}/proposals`;
export const CLUB_MEMBERS = `${DASHBOARD_BASE_URL}/club-members`;
export const USER_MEMBERSHIPS = `${CLUB_MEMBERS}/memberships`;
export const USERS = "users";
export const USERS_CHART_INFO = `${DASHBOARD_BASE_URL}/users/chart-info`;
export const DASHBOARD_STAKINGS = `${DASHBOARD_BASE_URL}/staking`;
export const DASHBOARD_WITHDRAWAL = `${DASHBOARD_BASE_URL}/withdrawal`;
export const DASHBOARD_TREASURY = `${DASHBOARD_BASE_URL}/treasury`;
export const DASHBOARD_WHITELISTING = `whitelisting`;
export const CLUBS_OVERVIEW = `${DASHBOARD_CLUBS}/overview`;
export const USERS_OVERVIEW = `${CLUB_MEMBERS}/overview`;
export const PROPOSAL_OVERVIEW = `${PROPOSAL}/overview`;
export const TREASURY_BUY_CHART_INFO = `${TREASURY}/buy-chart-info`;
export const TREASURY_SELL_CHART_INFO = `${TREASURY}/sell-chart-info`;
export const CLUBS_CHART_INFO = `${DASHBOARD_CLUBS}/chart-info`;
export const CLUBS_TABLE_INFO = `${DASHBOARD_CLUBS}/table-info`;
export const PROPOSALS = `${DASHBOARD_BASE_URL}/proposals`;
export const STAKING = `${DASHBOARD_BASE_URL}/staking`;
export const PROPOSALS_OVERVIEW = `${PROPOSALS}/overview`;
export const STAKING_OVERVIEW = `${STAKING}/overview`;
export const TREASURY_OVERVIEW = `${DASHBOARD_TREASURY}/overview`;
export const TOTAL_MONEY_SPEND = `${DASHBOARD_TREASURY}/total-money-spend-chart`;
export const BUY_CHART_INFO = `${DASHBOARD_TREASURY}/buy-chart-info`;
export const SELL_CHART_INFO = `${DASHBOARD_TREASURY}/sell-chart-info`;
export const PROFIT_LOSS = `${DASHBOARD_TREASURY}/sell-chart-info`;
export const TREASURY_TRADING_TABLE = `${DASHBOARD_TREASURY}/trading-table/5`;
export const WITHDRAWAL_OVERVIEW = `${DASHBOARD_WITHDRAWAL}/overview`;
export const WITHDRAWAL_CHART = `${DASHBOARD_WITHDRAWAL}/chart-info`;
export const CHANGE_STATUS = `${DASHBOARD_WHITELISTING}/change-status`;
export const BULK_CHANGE_STATUS = `${DASHBOARD_WHITELISTING}/bulk`;
export const DISCORD = "discord";
export const REFRESH_DISCORD_USERNAME = `${DISCORD}/refresh-username`;

export const CRON_TIMESTAMP = `${DASHBOARD_BASE_URL}/cron-timestamp`;
export const SOL_USDT = `https://www.binance.com/api/v3/ticker/price?symbol=SOLUSDT`;

export const AUTH_BASE_URL = "auth";
